import React from 'react';

function GoogleRecaptchaBadge({show}) {
	return (
		<div id="app-recaptcha-badge-container" style={{display: show ? "block" : "none"}}></div>
	);
}

export default GoogleRecaptchaBadge;
